import React from "react";
import { RECRUITMENT_ADS_CONFIG } from "./constants";
import { FormConfigPage } from "./FormConfigPage";

export function RecruitmentAds() {
    return <FormConfigPage config={RECRUITMENT_ADS_CONFIG} />;
}
